import React, { useEffect, useState } from "react";
import HeaderDropdown from "../HeaderDropdown";
import MatchTitle from "../items/MatchTitle";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import LiveMatchContainer from "../cards/LiveMatchContainer";
import TeamHolder from "../../assets/TeamHolder.svg";
import TeamHolder2 from "../../assets/TeamHolder2.svg";
import Vs from "../../assets/VsIcon.svg";
import {
  isMobile,
  LiveScoreType,
  mapAbbrToLogo,
  mapAbbrToLogoWithURL,
  QuestionType,
} from "../../types/type";
import { MatchType } from "../MatchHeaderDropdown";
import { answerInterface } from "./QuestionSegment";
import { UserPick } from "../../services";

interface SegmentProps {
  matchHasStarted?: boolean;
  matchWillStartIn?: string;
  match: MatchType;
  amount?: string;
  answer?: UserPick[];
}

function LiveScoreBoardSegment({
  matchHasStarted,
  matchWillStartIn,
  match,
  amount,
  answer,
}: SegmentProps) {
  const [countdown, setCountdown] = useState<string>("");
  useEffect(() => {
    if (matchWillStartIn) {
      const targetTime = new Date(matchWillStartIn).getTime();
      const interval = setInterval(() => {
        const remainingTime = Math.max(targetTime - Date.now(), 0);
        const hours = Math.floor(remainingTime / (1000 * 60 * 60))
          .toString()
          .padStart(2, "0");
        const minutes = Math.floor(
          (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
        )
          .toString()
          .padStart(2, "0");
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)
          .toString()
          .padStart(2, "0");
        setCountdown(`${hours}:${minutes}:${seconds}`);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [matchWillStartIn]);
  return (
    <div
      className="relative flexColumn itemsCenter"
      style={{ marginBottom: 100 }}
    >
      <MatchTitle />
      <HeaderDropdown ajioIconHeight={98} ajioIconWidth={98}>
        <div className="otherLiveScoreBoardHeader">
          <CustomText
            size="large"
            weight="400"
            spacing={4}
            color={Colors.blueGray}
            textAlign="center"
            style={{ width: "90%", maxWidth: 440 }}
            marginTop={30}
          >
            {matchHasStarted
              ? "MATCH HAS ALREADY STARTED"
              : "MATCH WILL START IN"}
          </CustomText>
          {matchWillStartIn && !matchHasStarted && (
            <CustomText
              size="large"
              weight="400"
              spacing={4}
              color={Colors.blueGray}
              textAlign="center"
              style={{ width: "90%" }}
            >
              {countdown}
            </CustomText>
          )}
          <CustomText
            size="smallMedium"
            weight="400"
            marginTop={15}
            color={Colors.white}
          >
            Total prizes worth{" "}
            <CustomText
              size="smallMedium"
              weight="700"
              marginTop={15}
              color={Colors.white}
            >
              ₹{amount}{" "}
            </CustomText>
          </CustomText>
        </div>
      </HeaderDropdown>
      <div
        style={{
          marginTop: -100,
          position: "relative",
          width: "100%",
          height: 150,
        }}
      >
        <div
          style={{
            width: "100%",
            alignItems: "center",
            flexDirection: "column",
            display: "flex",
            zIndex: 1,
          }}
        >
          <img src={TeamHolder} alt="" className="otherTeamHolderImage" />
          <img src={TeamHolder2} alt="" className="otherTeamHolderImage2" />
        </div>
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            top: 0,
            position: "absolute",
          }}
        >
          <div className="otherTeamHolderContent">
            <div
              style={{
                flex: 1,
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <img
                src={mapAbbrToLogoWithURL(match, false).logo}
                style={{
                  width: isMobile ? 55 : 100,
                  height: isMobile ? 55 : 100,
                  objectFit: "contain",
                }}
                alt=""
              />
            </div>

            <img
              src={Vs}
              style={{
                width: isMobile ? 55 : 100,
                height: isMobile ? 55 : 100,
                objectFit: "contain",
                display: "flex",
                flex: 1,
                marginTop: 60,
              }}
              alt=""
            />

            <div
              style={{
                flex: 1,
                alignItems: "center",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                src={mapAbbrToLogoWithURL(match, true).logo}
                style={{
                  width: isMobile ? 55 : 100,
                  height: isMobile ? 55 : 100,
                  objectFit: "contain",
                }}
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div className="otherLiveScoreTitleMargin">
        <div className="otherLiveScoreTitleMobile">
          <CustomText
            size="smallMedium"
            weight="500"
            spacing={4}
            color={Colors.blueGray}
            textAlign="center"
            marginTop={25}
          >
            LIVE SCORE BOARD
          </CustomText>
        </div>
        <div className="otherLiveScoreTitleDesktop">
          <CustomText
            size="large"
            weight="500"
            spacing={4}
            color={Colors.blueGray}
            textAlign="center"
            marginTop={40}
            marginBottom={20}
          >
            LIVE SCORE BOARD
          </CustomText>
        </div>
      </div>
      {answer?.map((matc: UserPick, index) => (
        <LiveMatchContainer
          match={matc}
          number={index + 1}
          // liveMatch={matchHasStarted}
        />
      ))}
    </div>
  );
}

export default LiveScoreBoardSegment;
